<template>
<div class="container">
  <b-overlay :show="isLoading" rounded="sm" variant="dark">
    <div class="row">
      <div class="col offset-10">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-default btn-flag-selected" @click="setLanguage('ca')"><lang-flag iso="ca" title="Català" :squared="false"/></button>
          <button type="button" class="btn btn-default btn-flag-selected" @click="setLanguage('es')"><lang-flag iso="es" title="Castellano" :squared="false"/></button>
          <button type="button" class="btn btn-default btn-flag-selected" @click="setLanguage('en')"><lang-flag iso="en" title="English" :squared="false"/></button>
        </div>
      </div>
    </div>
    <div class="row" v-show="surveyOpen">
      <div class="card">
        <div class="card-header">
          <p class="text-center" v-show="!ended">{{ $t('header.sub_title') }}</p>
          <p class="text-center" v-show="!ended">{{ $t('header.description') }}</p>
        </div>
        <div class="card-body">
          <form-wizard ref="formulariMatricula"
              v-show="!ended"
              @on-complete="onComplete"
              shape="tab"
             :title="$t('title')"
             :subtitle="$t('sub_title')"
             :nextButtonText="$t('btns_form.next')"
             :backButtonText="$t('btns_form.previous')"
             :finishButtonText="$t('btns_form.submit')"
              color="#F5AF03"
          >
            <tab-content :title="$t('tabs.personal_data.title')" :before-change="()=>validateStep('dades-personals')">
              <dades-personals ref="dades-personals" @on-validate="mergePartialModels" :lang="language"></dades-personals>
            </tab-content>
            <tab-content :title="$t('tabs.photo.title')" :before-change="()=>validateStep('fotografia')">
              <foto ref="fotografia" @on-validate="mergePartialModels" :lang="language"></foto>
            </tab-content>
            <tab-content :title="$t('tabs.academic_data.title')" :before-change="()=>validateStep('dades-academiques')">
                <dades-academiques ref="dades-academiques" @on-validate="mergePartialModels" :lang="language"></dades-academiques>
              </tab-content>
            <tab-content :title="$t('tabs.title_selection.title')" :before-change="()=>validateStep('per-que-tecnocamppus')">
                <per-que-tecnocampus ref="per-que-tecnocamppus" @on-validate="mergePartialModels" :lang="language"></per-que-tecnocampus>
              </tab-content>
              <tab-content :title="$t('tabs.expectations.title')" :before-change="()=>validateStep('expectatives-i-opinio')">
                <expectatives-i-opinio ref="expectatives-i-opinio" @on-validate="mergePartialModels" :lang="language"></expectatives-i-opinio>
              </tab-content>
              <tab-content :title="$t('tabs.comunication.title')" :before-change="()=>validateStep('comunicacio')">
                <comunicacio ref="comunicacio" @on-validate="mergePartialModels" :lang="language"></comunicacio>
              </tab-content>
              <tab-content :title="$t('tabs.transport.title')" :before-change="()=>validateStep('transport')">
                <transport ref="transport" @on-validate="mergePartialModels" :lang="language"></transport>
              </tab-content>
              <tab-content :title="$t('tabs.impressions.title')" :before-change="()=>validateStep('primeres-impressions')">
                <primeres-impressions ref="primeres-impressions" @on-validate="mergePartialModels" :lang="language"></primeres-impressions>
              </tab-content>
          </form-wizard>

          <div v-show="ended">
            <end :finalObject="finalModel" :lang="language"></end>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-danger" role="alert"  v-show="!surveyOpen">
      <h4 class="alert-heading"><i class="fa fa-exclamation-circle"></i> {{ $t('survey_close.msg') }}</h4>
      <p> {{ $t('survey_close.sub_msg') }} </p>
    </div>
  <div v-show="sending" class="overlay center-element"><h1 class="text-center text-white">Wait...</h1></div>
  </b-overlay>
</div>    
</template>

<script>

import DadesPersonals from './tabs/dades-personals.vue'
import Foto from './tabs/foto.vue'
import DadesAcademiques from './tabs/dades-academiques.vue'
import PerQueTecnocampus from './tabs/per-que-tecnocampus.vue'
import ExpectativesIOpinio from './tabs/expectatives-i-opinio.vue'
import Transport from './tabs/transport'
import PrimeresImpressions from './tabs/primeres-impressions'
import Comunicacio from './tabs/comunicacio'
import End from './tabs/end'
import config from "@/config";
import bus from "@/helpers/event_bus";
import es from 'vee-validate/dist/locale/es';
import ca from 'vee-validate/dist/locale/ca';
import en from 'vee-validate/dist/locale/en';


export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Formulari',
  props: { lang: { required:true, default:'ca'} },
  components: { DadesPersonals, Foto, DadesAcademiques, PerQueTecnocampus, ExpectativesIOpinio, Transport, PrimeresImpressions, Comunicacio, End },
  data() {
    return {
      ended: false,
      finalModel: {},
      sending: false,
      surveyDates: [],
      surveyOpen: true,
      isLoading: true,
      language: 'ca'
    }
  },
  created() {
    this.language = this.lang;
    console.log('LEines ' + process.env.VUE_APP_LEINES_HOST);
    this.getDates();
  },
  methods: {
    onComplete: function() {
      this.sending = true;
      let formData = new FormData();
      formData.append('foto', this.finalModel.foto);
      Object.entries(this.finalModel).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Removing unnecessary fields
      formData.delete('studies');
      formData.delete('locations');
      formData.delete('provincias');
      formData.delete('municipios');
      formData.delete('optionsSiCompaginarEstudis');
      formData.delete('optionsResidencesTypes');
      formData.delete('optionsGeneres');
      formData.delete('optionsCompaginarEstudis');
      formData.delete('options_com_has_conegut');
      formData.delete('options_tipus_batxillerat');

      for (const key of formData.keys()) {
        if (key.startsWith("options_")) {
          formData.delete(key);
        }
      }

      this.axios.post(process.env.VUE_APP_LEINES_HOST+'survey/graus/save', formData, config.headers_api)
          .then((response) => {
            this.finalModel.token = response.data.token;
            this.finalModel.created_at = response.data.created_at;
            this.finalModel.id = response.data.id;
            bus.$emit('survey-ended',this.finalModel);
            this.ended = true;
            this.$swal('Enquesta guardada!!!','','success');
          })
          .catch(response => {
            this.ended = false;
            console.log(response);
            this.$swal('Hi ha hagut un error al guardar!!!','','error');
          }).finally(() => this.sending = false );
    },
    validateStep(tab) {
      var form = this.$refs[tab];
      return form.validate();
    },
    mergePartialModels(model, isValid){
      if(isValid){
        // merging each step model into the final model
        this.finalModel = Object.assign({},this.finalModel, model);
      }
    },
    getDates(){
      this.axios.get(process.env.VUE_APP_LEINES_HOST+'survey/graus/dates', config.headers_api)
          .then(response => {
            this.surveyDates = response.data;
            let dateNow = Date.now();
            this.surveyDates.data_inici.replace(/\//g,'-');
            this.surveyDates.data_fi.replace(/\//g,'-');
            let data_inici = Date.parse(this.surveyDates.data_inici);
            let data_fi = Date.parse(this.surveyDates.data_fi);
            console.log('inici ' + data_inici);
            console.log('fi ' + data_fi);
            console.log('now ' + dateNow);
            if(!(dateNow > data_inici && dateNow < data_fi) && config.environment === 'production') this.surveyOpen = false;
          })
          .catch(response => {
            console.log(response);
          }).finally(() => this.isLoading = false );
    },
    setLanguage(lang){
      this.$i18n.locale = lang;
      this.language = lang;

      if(lang === 'es') this.$validator.localize(es);
      else if(lang === 'en') this.$validator.localize(en);
      else this.$validator.localize(ca);
    }
  }
}
</script>